import Styles from './AutoScheduledButtons.module.scss'
import { CalendarTrash, Folder, Close } from 'blaze-ui/icons'
import { MobileButton } from 'components/MobileButton/MobileButton'
import { Send2 } from 'blaze-ui/icons/24'
import { Button } from 'blaze-ui/Button'
import { Text } from 'blaze-ui/Text/Text'

interface Props {
  onOpenProject: () => void
  onPostNow?: () => void
  onUnschedule?: () => void
  onCrossPost?: () => void
  onClose?: () => void
  isExisting?: boolean
}

export const AutoScheduledButtons = ({
  onOpenProject,
  onPostNow,
  onUnschedule,
  onCrossPost,
  onClose,
  isExisting = false,
}: Props) => {
  if (isExisting) {
    return (
      <div className={Styles.root}>
        <Button size="xl" frontIcon={Folder} onPress={onCrossPost} variant="primary">
          Cross Post to other platforms
        </Button>
        <div className={Styles.secondaryActions}>
          <MobileButton size="sm" icon={Folder} onPress={onOpenProject} variant="tertiary">
            Open Project
          </MobileButton>
          <MobileButton size="sm" icon={Send2} onPress={onPostNow} variant="tertiary">
            Post Now
          </MobileButton>
          <MobileButton size="sm" icon={CalendarTrash} onPress={onUnschedule} variant="tertiary">
            Unschedule
          </MobileButton>
        </div>

        <Text variant="metadata" color="var(--dark-40)">
          Unscheduled files will not be deleted.
        </Text>
      </div>
    )
  }

  return (
    <div className={Styles.root}>
      <Button size="lg" frontIcon={Folder} onPress={onOpenProject} variant="primary">
        Open Project
      </Button>

      <Button size="lg" frontIcon={Close} onPress={onClose} variant="tertiary">
        Close
      </Button>
    </div>
  )
}
